<template>
  <div>
    <vue-headful :title="page.fields.seo.seo_title" :description="page.fields.seo.meta_description" url="https://alabama.travel/subscribe"/>

    <div>
      <div class="row">
        <div class="col-12 hero-image">
          <Banner class="hero-image" :bannerId="page.fields.hero.hero_image" type="image"
      :description="page.fields.hero.hero_description"  />        </div>
      </div>
    </div>
    <div class="container">
      <div aria-live="polite">
          <ul>
              <li v-for="error in errors" :key="error.vmId">{{ error.msg }}</li>
          </ul>
      </div>
      <div class="row">
        <div class="col-lg-7 text-left">
          <h1>{{ this.page.fields.paragraph_header }}</h1>
          <p>{{  this.page.fields.paragraph }}</p>

          <b-form v-on:submit.prevent v-on:submit.exact="onSubmit">
              <label for="First">First Name:</label>
              <b-form-input id="first_name" name="first name" type="text" v-model="form.first_name"
                  v-validate="{ required: true }" placeholder="First Name"
                  :state="validateState('form.first_name')" />

              <label for="Last">Last Name:</label>
              <b-form-input id="last_name" name="last name" type="text" v-model="form.last_name"
                  v-validate="{ required: true }" placeholder="Last Name"
                  :state="validateState('form.last_name')" />

              <label for="Email">Email:</label>
              <b-form-input id="email" name="email" type="email" v-model="form.email"
                  v-validate="{ required: true, email: true }" placeholder="Email"
                  :state="validateState('form.email')" />

              <fieldset>
                <h2>Your Interests</h2>

                <b-form-checkbox id="FoodInterest"        value="Food"        v-model="interests">Food & Drink</b-form-checkbox>
                <b-form-checkbox id="ArtsInterest"        value="Arts"        v-model="interests">Arts & Culture</b-form-checkbox>
                <b-form-checkbox id="BeachesInterest"     value="Beaches"     v-model="interests">Beaches</b-form-checkbox>
                <b-form-checkbox id="CivilRightsInterest" value="CivilRights" v-model="interests">Civil Rights Legacy</b-form-checkbox>
                <b-form-checkbox id="MusicInterest"       value="Music"       v-model="interests">Music</b-form-checkbox>
                <b-form-checkbox id="GolfInterest"        value="Golf"        v-model="interests">Year Round Golf</b-form-checkbox>
                <b-form-checkbox id="HistoryInterest"     value="History"     v-model="interests">History</b-form-checkbox>
                <b-form-checkbox id="OutdoorInterest"     value="Outdoor"     v-model="interests">Outdoors</b-form-checkbox>
                <b-form-checkbox id="SportsInterest"      value="Sports"      v-model="interests">Sports</b-form-checkbox>
                <b-form-checkbox id="ScienceInterest"     value="Science"     v-model="interests">Science & Discovery</b-form-checkbox>

                <b-button type="submit" :disabled="errors.any()" >Submit</b-button>
              </fieldset>
          </b-form>
        </div>
        <aside class="col-lg-5 text-left avg-magazine" aria-label="Online Vacation Gudie">
          <img src="/images/vacation-guide/vacation-guide-open.jpg" alt="Cover of Sweet Home Alabama Magazine">
          <router-link class="button float-right" to="/online-vacation-guide" target="_blank" rel="noopener noreferrer">View Online Vacation Guide<span class="ani-chevron">></span></router-link>
        </aside>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import Butter from 'buttercms';
import axios from 'axios';
import Footer from '@/components/Common/Footer.vue';
import Banner from '../../components/Common/Banner.vue';

let orderPage;

export const butter = Butter('eb418357164849860c223876bb84811162582149');

@Component({
  data() {
    return {
      interests: [],
      page: {
        fields: {
          seo: {},
          hero: {},
        },
      },
    };
  },
  async created() {
    await this.getPage();
  },
  components: {
    Footer,
    Banner,
  },
  methods: {
    getPage() {
      butter.page.retrieve('*', 'newsletter', { preview: `${process.env.VUE_APP_BUTTER_PREVIEW}` })
        .then((res) => {
          this.page = res.data.data;
        }).catch((res) => {
          console.log(res);
        });
    },
  },
})
class NewsletterOrderForm extends Vue {
  form = {};

  mounted() {
    // keep reference
    orderPage = this;
  }

  async onSubmit() {
    let errortext;

    const interestsString = `{${orderPage.interests.join(',')}}`;

    try {
      await axios.post(`${process.env.VUE_APP_SUBSCRIBE_API}addSubscriber`, {
        first_name: this.form.first_name,
        last_name: this.form.last_name,
        email: this.form.email,
        interests: interestsString,
      }, {
        headers: {
          'Access-Control-Allow-Origin': '*',
          Accept: 'application/json',
        },
      }).then(() => {
        orderPage.$router.push({ name: 'newsletter thanks' });
      }).catch((error) => { errortext = error; });
    } catch (e) {
      errortext = e;
      return errortext;
    }
    return errortext;
  }

  validateState(ref) {
    if (this.$validator.fields[ref] && (this.$validator.fields[ref].dirty || this.$validator.fields[ref].validated)) {
      return !this.errors.has(ref);
    }
    return null;
  }
}

export default NewsletterOrderForm;
</script>

<style lang="scss" scoped>


aside {
margin: 50px 0 150px;
}
button {
margin-top:40px;
}
fieldset {
margin-top: 50px;
}
h1 {
font-family: 'klinicslabBook';
font-size:64px;
line-height:70px;
margin-top:40px;
}
label {
font-family: 'IdealSans-Medium';
color: #6c767f!important;
font-style: italic;
margin-bottom:0px;
margin-top:20px;
font-size:22px;
}
.hero-image {
padding-left:0px;
padding-right:0px;

&:after {
  content: " ";
  bottom: -10px;
  background-image: url(/images/newsletter/newsletter.svg);
  background-position: center;
  background-repeat: no-repeat;
  background-size: 60%;
  display: block;
  height: 50%;
  opacity: .3;
  z-index: 100;
  position: absolute;
  width: 100vw;

}
}
</style>
